import { Box, Button, Dialog, TextField, Typography, useTheme } from "@mui/material"
import { font } from "../../styles/font"
import { useEffect, useState } from "react";
import { useApplicationContext } from "../../context/ApplicationContext";
import { Entity_Label } from "../../constant/ApplicationVariables";
import { Trans, useTranslation } from "react-i18next";

export default function DeleteModuleDialog({ open, handleClose, handleConfirm, loading, setLoading }) {
  const { currentFolderData } = useApplicationContext();
  const theme = useTheme();
  const { t } = useTranslation("translation", { keyPrefix: "sidebar.folder" });

  const handleContinue = () => {
    handleConfirm();
  }

  // Determine button text color based on theme mode
  const getButtonTextColor = () => {
    return theme.palette.mode === 'light' ? '#ffffff' : '#000000';
  }

  return (
    <Dialog open={open} onClose={handleClose}
      sx={{ "& .MuiDialog-paper": { width: "100%", maxWidth: "400px" } }}
    >
      <Box className="flex flex-col gap-4 px-4 py-2">
        <Box className="flex items-center justify-between gap-4">
          <Typography 
            fontSize={font.size.fs_4} 
            color={theme.palette.primary.main}  // Primary color for header
          >
            <Trans
              t={t}
              i18nKey="delete"
              defaults="Delete {{moduleText}}" // optional defaultValue
              values={{ moduleText: Entity_Label.folder, }}
            />
          </Typography>
        </Box>

        <Box className="flex flex-col gap-2">
          <Typography 
            fontSize={font.size.fs_4}
            color={theme.palette.text.secondary}
          >
            {`Are you sure you want to delete this ${Entity_Label.folder}?`}
          </Typography>
          <Typography 
            fontSize={font.size.fs_4} 
            color={theme.palette.warning.main}  // Use warning color for warning text
          >
            {`This action is irreversible and will delete all items inside '${currentFolderData?.name}'.`}
          </Typography>
        </Box>

        <Box className="flex items-center justify-end gap-2">
          <Button 
            disabled={loading} 
            onClick={handleClose}
            sx={{
              backgroundColor: theme.palette.error.main,
              color: getButtonTextColor(),  // White in light, black in dark
              '&:hover': {
                backgroundColor: theme.palette.error.main,
              },
              '&:disabled': {
                backgroundColor: theme.palette.action.disabledBackground,
                color: theme.palette.action.disabled,
              }
            }}
          >
            {t("cancelText")}
          </Button>
          <Button 
            disabled={loading} 
            onClick={handleContinue}
            sx={{
              backgroundColor: theme.palette.primary.main,
              color: getButtonTextColor(),  // White in light, black in dark
              '&:hover': {
                backgroundColor: theme.palette.primary.main,
              },
              '&:disabled': {
                backgroundColor: theme.palette.action.disabledBackground,
                color: theme.palette.action.disabled,
              }
            }}
          >
            {t("continueText")}
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
}